<template>
  <el-dialog custom-class="bear-points-collection"
    v-model="dlgVisible"
    width="522px"
    :close-on-click-modal="false"
    :append-to-body="true"
    :show-close="false"
  >
    <el-icon class="bpc__close" @click="close"><Close /></el-icon>
    <img v-if="form.IS_REPORT_PROVINCE_OUTSIDE" src="./img/积分兑换弹窗_2.png" alt="tc">
    <img v-else src="./img/积分兑换弹窗.png" alt="tc">
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import { Close } from '@element-plus/icons-vue'
export default {
  name: 'BearPointsCollection',
  components: { Close },
  data() {
    return {
      codes: ['x00004', 'x60004', 'x70001'],
      dlgVisible: false,
      IS_REPORT_PROVINCE_OUTSIDE: false
    }
  },
  computed: {
    ...mapState(['form'])
  },
  methods: {
    init(json) {
      let { StatusList, Detail: { regionId, eval: evalName } } = json
      let { codes } = this
      let visible = codes.indexOf(regionId) >= 0 && evalName !== '线下评标'
      let hasPublishButWaitAudit = StatusList.indexOf('hasPublishButWaitAudit') >= 0
      let published = StatusList.indexOf('published') >= 0

      if(visible) {
        this.IS_REPORT_PROVINCE_OUTSIDE = hasPublishButWaitAudit && !published
        this.dlgVisible = hasPublishButWaitAudit || published
      }
    },
    close() {
      this.dlgVisible = false
    }
  }
}
</script>
<style lang="scss">
.bear-points-collection {
  background: none;
  --el-border-radius-small: 15px;
  .el-dialog__header, .el-dialog__footer {
    display: none;
  }
  .el-dialog__body {
    position: relative;
    padding: 0;
    width: 522px;
    height: 453px;
  }
  .bpc {
    &__close {
      position: absolute;
      padding: 2px;
      top: 10px;
      right: 10px;
      color: white;
      font-size: 15px;
      border: 1px solid white;
      border-radius: 100%;
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    }
  }
}  
</style>